import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-organisation-admin',
  templateUrl: './organisation-admin.component.html',
  styleUrls: ['./organisation-admin.component.css']
})
export class OrganisationAdminComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
